import { axiosGet } from "./axiosFunctions";

const getOrderByTransactionIDUrl                            = '/api/payment/getOrderByTransactionID';
const initiatePaymentUrl                                    = '/api/payment/initiatePayment';


export const getOrderByTransactionID = async (transactionID) => {   
    const response = await axiosGet(getOrderByTransactionIDUrl, { headers: '', params: {transactionID}});
    return response;
}

export const initiatePayment = async(orderId) => { 
    const response = await axiosGet( initiatePaymentUrl, { headers: '', params:{ orderId }} );
    return response;
}